import { memo, useEffect, useState } from 'react';

import { Chart } from "primereact/chart";

import ChartDataLabels from 'chartjs-plugin-datalabels';

export const RevisaoDefeitoTear = memo(function RevisaoDefeitoTear({ dataProd, defeitos, month, setor }) {
    const [chartData, setChartData] = useState(null);

    const chartOptions = {
        maintainAspectRatio: false,
        plugins: {
            datalabels: {
                anchor: 'end',
                align: 'end',
                formatter: (value) => {
                    return parseInt(value);
                },
                font: {
                    size: 14,
                    weight: 'bold',
                },
                color: "#2c3e50"
            },
        },
    }

    useEffect(() => {
        if (setor === 1) {
            let defeitosF = defeitos.filter((element) => { return parseInt(element.mes) === month && element.cod_defeitotipo === setor });

            let defeitosO = defeitosF.sort((a, b) => {
                if (a.cod_tear > b.cod_tear) return -1
                else if (a.cod_tear < b.cod_tear) return 1
                else return 0
            });

            if(defeitosO.length === 0)
                return; 

            let totalDefeito = 0

            defeitosO.forEach((item) => {
                totalDefeito += parseFloat(item.soma);
            });

            let maximo = defeitosO[0].cod_tear;

            let teardefeito = [];

            for (let i = 1; i <= maximo; i++) {
                let defeitosOTear = defeitosO.filter((element) => {
                    return element.cod_tear === i;
                });

                let producaoTear = dataProd.filter((element) => {
                    return element.tear === i && element.setor === 'Tecelagem' && parseInt(element.mes) === month;
                });

                let totalProducao = 0;

                producaoTear.forEach((item) => {
                    totalProducao += parseFloat(item.soma);
                });

                let total = 0;
                defeitosOTear.forEach((defeito) => {
                    total += parseFloat(defeito.soma);
                });

                if (total > 0) {
                    teardefeito.push({
                        'tear': i,
                        'total': total,
                        'producao': parseInt(totalProducao),
                        'defeitoxproducao': totalProducao > 0 ? (total / totalProducao * 100) : 0
                    });
                }
            }

            teardefeito = teardefeito.sort((a, b) => { return a.defeitoxproducao > b.defeitoxproducao ? -1 : 1 });

            let teares = [];
            let valores = [];

            let pareto = 0;
            let i = 0;

            while(pareto / totalDefeito * 100 < 80) {
                teares.push([teardefeito[i].tear, teardefeito[i].producao, String(teardefeito[i].defeitoxproducao.toFixed(1)) + '%']);
                valores.push(teardefeito[i].total);
                pareto += teardefeito[i].total;
                i += 1;
            }

            let _chartData = {
                labels: teares,
                datasets: [
                    {
                        backgroundColor: "#48dbfb",
                        data: valores,
                        label: 'Defeitos por Tear'
                    }
                ]
            }

            setChartData(_chartData);
        }


    }, [dataProd, defeitos, month, setor])

    if (setor !== 1 || defeitos.length === 0)
        return null;

    return (
        <div className='p-col-12'>
            {chartData !== null && (
                <Chart
                    data={chartData}
                    height="350px"
                    options={chartOptions}
                    plugins={[ChartDataLabels]}
                    type="bar"
                />
            )}
        </div>
    )
});